module.exports = __webpack_public_path__ + "img/leaf.b49e62ce.svg";